module.exports = __webpack_public_path__ + "static/fonts/PostGrotesk-Medium.c9c26dde.woff";